/**
 * Formats a remaining-seconds value as `mm:ss`, matching the legacy
 * legacy ASM timer display (zero-padded minutes and seconds).
 */
export function formatAsmTimer(seconds: number): string {
  const safe = Math.max(0, Math.floor(seconds));
  const min = Math.floor(safe / 60);
  const sec = safe % 60;
  const minText = min < 10 ? `0${min}` : `${min}`;
  const secText = sec < 10 ? `0${sec}` : `${sec}`;
  return `${minText}:${secText}`;
}
